import { Backdrop } from '@material-ui/core'
import React, { FC, useState } from 'react'
import { Helmet } from 'react-helmet'
import { VIDEO } from '../../../constants/urls'
import { tencentVideoPlay } from '../../../utils/cn.utils'
import Button from '../button'
import DottedModal from '../dottedModal'
import { HTMLVideo } from '../videoPlayer/style'

type Props = {
  videoId: string
  videoUrl: string
  width: string
  height: string
  type?: string
  start?: string
  className?: string
  playInPlace?: boolean
  animationFileUrl?: string
  ctaText?: string
  ctaType: 'primary' | 'secondary' | 'tertiary' | 'text-link' | 'icon' | 'inline-text-link'
  ctaTheme: 'light' | 'dark' | string
  ctaSize?: 'small' | 'medium' | 'large'
}

const VideoCta: FC<Props> = ({
  videoId,
  videoUrl,
  width,
  height,
  type = 'youtube',
  start,
  className,
  playInPlace = false,
  animationFileUrl,
  ctaText = '',
  ctaType,
  ctaTheme,
  ctaSize,
}) => {
  const vidWidth = width === '100%' ? '100%' : `${width}px`
  const [startVideo, setStartVideo] = useState(false)
  const [open, setOpen] = useState(false)

  const playInPlaceVideo = () => setStartVideo(true)
  const handleClose = () => setOpen(false)

  const handleOpen = () => {
    setOpen(true)

    type === 'tencent-video'
      ? setTimeout(function () {
          tencentVideoPlay(videoUrl)
        }, 500)
      : null
  }

  const url: { [key: string]: string } = {
    youtube: `${VIDEO.YOUTUBE}/embed`,
    vimeo: `${VIDEO.VIMEO}/video`,
  }

  let src = ''
  if (videoId && type !== 'html-video') {
    src = `${url[type]}/${videoId}`

    //* videoId can contain query string (vimeo)
    //* video will not have autoplay/start if not valid url
    try {
      let videoEmbedUrl = new URL(src)
      if (videoEmbedUrl.search) {
        src += '&autoplay=1'
      } else {
        src += '?autoplay=1'
      }
      src += start ? `&start=${start}` : ''
    } catch (err) {
      console.log(err)
    }
  } else if (animationFileUrl) {
    src = animationFileUrl
  }

  let videoElem = (
    <iframe
      width="100%"
      height={height || '475'}
      src={src}
      allowFullScreen
      data-cy={`VideoPlayer-Modal--${type}`}
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    />
  )

  if (type === 'html-video') {
    videoElem = (
      <HTMLVideo width={vidWidth} height={height} controls id="videoSpotlight-html-video">
        <source src={videoUrl} type="video/mp4" />
      </HTMLVideo>
    )
  }

  if (type === 'tencent-video') {
    videoElem = (
      <HTMLVideo
        width={vidWidth}
        height={height}
        controls
        id="tencentVideoPlayer"
        preload="auto"
        autoPlay
      />
    )
  }

  const modalVideo = (
    <DottedModal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      vType={type}
      open={open}
      handleClose={handleClose}
      closeAfterTransition
      type="video"
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
      type="video">
      {videoElem}
    </DottedModal>
  )

  return (
    <>
      <Helmet>
        <script src="https://cdn.jsdelivr.net/npm/hls.js@latest" type="text/javascript" />
      </Helmet>

      {playInPlace && startVideo ? videoElem : modalVideo}
      {!startVideo && (
        <Button
          icon={true}
          href={'javascript:void(0);'}
          text={ctaText}
          type={ctaType}
          theme={ctaTheme}
          size={ctaSize}
          target={'_self'}
          className={className}
          clickHandler={playInPlace ? playInPlaceVideo : handleOpen}
        />
      )}
    </>
  )
}

export default VideoCta
